<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Staffs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_staff' }" class="btn btn-primary float-end">Add Staff</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchStaffs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchStaffs()">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchStaffs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>ID</th>  
                                            <th>Name</th>
											<th>Contact & Username</th>
											<th>Status</th> 
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(staffs.length)">
                                        <tr align="center" v-for="(staff, index) in staffs" :key="staff.id">
                                            <td>#{{staff.id}}</td>
                                            <td>{{staff.name}}</td>
											<td>{{staff.country_code}} {{staff.mobile}} <br>
												{{staff.user_name}}
											</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="staff.status==1">Active</span>
												<span class="badge rounded-pill bg-danger" v-if="staff.status==2">Blocked</span>
											</td>
											<td>
												<router-link :to="{ name: 'staff_details',params: { id: staff.id }  }" class="btn btn-primary me-1 mb-2 btn-sm">Profile</router-link>
												<router-link :to="{ name: 'edit_staff',params: { id: staff.id }  }" class="btn btn-primary me-1 mb-2 btn-sm">Edit</router-link>
												<router-link :to="{ name: 'staff_logs', params: { id: staff.id } }" class="btn btn-info me-1 mb-2 btn-sm">Logs</router-link>
												<a variant="danger" class="btn btn-danger me-1 mb-2 btn-sm" @click="deactivateStaff(staff)" v-if="staff.status==1">Block</a>
												<a variant="success" class="btn btn-success me-1 mb-2 btn-sm" @click="activateStaff(staff)" v-if="staff.status==2">Activate</a>
												<a class="btn btn-danger me-1 mb-2 btn-sm" @click="deleteStaff(staff.id)">Delete</a>
                                            </td>
                                        </tr>

									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(staffs.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchStaffs(page.url + '&limit=' + listing_length + '&status=' + status + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="UpdatePassword" enctype="multipart/form-data">

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">New Password <span class="text-danger">*</span></label>
							<input class="form-control" v-model="password" type="password" placeholder="" />
						</div>
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Confirm Password <span class="text-danger">*</span></label>
							<input class="form-control"  v-model="confirm_password" type="text" placeholder="" />
						</div>	
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3">Update</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import {
    Tooltip
} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "User Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Change Password",
				button_title: "Update",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				status:"",

				staffs:[],

				organization: 1,

                button_title: "Save",

				staff_status: {
					id: "",
					status: ""
				},
				
         		// delete: false,
         		// active_page_url: null,
			};
		},

		mounted() {
            new Tooltip(document.body, {
                    selector: "[data-bs-toggle='tooltip']",
                })
        },
        unmounted() {

            let popovers = document.getElementsByClassName('tooltip')
            // popovers.forEach(item => {
            //     item.remove()
            // })

        },

		created() {

			this.fetchStaffs();

		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchStaffs(page_url = null) {
				this.getToken();
				let url = "/staffs/staffs?limit=" + this.listing_length  + "&status=" + this.status + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.staffs = responseData.staffs.data;
						this.pagination = responseData.staffs.links;
						this.from = responseData.staffs.from;
						this.to = responseData.staffs.to;
						this.total = responseData.staffs.total;
						
					})
					.catch((err) => console.log(err));
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            editUser() {
                this.errors = {};
				this.modal_title = "Edit User";
				this.button_title = "Update";
				this.showModal();
            },
			
			clearForm() {
				this.edit = false;
				this.modal_title = "Add User";
				this.button_title = "Add";
				this.errors = {};
			},

			activateStaff(staff) {
				let change_status = false;
				this.$swal({
							icon: 'warning',
							title:"Confirm",
							text:'Are you sure you want to activate this staff?',
							showCancelButton: true,
							confirmButtonText: 'Yes',
							confirmButtonColor: '#e64942',
							cancelButtonText: 'No',
							position: "center",
							showConfirmButton: true,
							timer: '',
							toast: false,
							cancelButtonColor: '#efefef',
							}).then((result)=>{
							if(result.value){
								this.staff_status.id = staff.id;
								this.staff_status.status = '1';
								this.updateStaffStatus();
							}
							
						});
			},
			deactivateStaff(staff) {
				let change_status = false;
				this.$swal({
							icon: 'warning',
							title:"Confirm",
							text:'Are you sure you want to deactivate this staff?',
							showCancelButton: true,
							confirmButtonText: 'Yes',
							confirmButtonColor: '#e64942',
							cancelButtonText: 'No',
							position: "center",
							showConfirmButton: true,
							timer: '',
							toast: false,
							cancelButtonColor: '#efefef',
							}).then((result)=>{
							if(result.value){
								this.staff_status.id = staff.id;
								this.staff_status.status = '2';
								this.updateStaffStatus();
							}
						});
			},

			updateStaffStatus() {
					
					this.getToken();
					const config = {
					headers: {
						"Content-type": "application/json",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
					};

					/* var formData = JSON.stringify({
					"staff_id": this.staff_status.id,
					"status": this.staff_status.status
					});
					*/
			
					let url = "staffs/updateStatus?staff_id=" + this.staff_status.id + "&status=" + this.staff_status.status;
			
					this.$axios
					.get(url, config)
					.then((response) => {                  
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchStaffs(this.active_page_url);
					})
					.catch((error) => {                
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
				},

				deleteStaff(staff_id) {
					this.delete = false;
					this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to delete this staff?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                     this.getToken();
                     const config = {
                        headers: {
                              'Authorization': 'Bearer ' + this.token,
                        }
                     };
                     this.$axios
                     .get('/staffs/deleteStaff?staff_id=' + staff_id, config)
                     .then(response => {
                        if(response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchStaffs();
                     })
                     .catch(error => {
                           if(error.response){
                              if(error.response.data.message){
                                 this.$swal("", error.response.data.message, "error");
                              } else {
                                 this.$swal("", "Something went wrong", "error");
                              }
                           } else {
                              this.$swal("", "Something went wrong", "error");
                           }
                           
                     });
					}
					
				});
      		},

			

		},
	};
</script>